/* eslint-disable max-len */
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { IReport } from '../../../../interfaces/IReport';

const styles = StyleSheet.create({
  rowEven: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px 0',
    marginTop: '3px',
    borderRadius: '3px',
    backgroundColor: '#fafafa',
  },
  rowOdd: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px 0',
    marginTop: '3px',
    borderRadius: '3px',
    backgroundColor: 'transparent',
  },
  thead: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: '8px 2px',
    backgroundColor: '#e0e0e0',
    borderRadius: '3px',
  },
  cellTdLarge: {
    width: '40%',
    marginRight: 10,
    fontSize: 10,
  },
  cellTdSmall: {
    width: '15%',
    fontSize: 10,
  },
  cellThLarge: {
    width: '40%',
    marginRight: 10,
    fontSize: 12,
    fontWeight: 'extrabold',
  },
  cellThSmall: {
    width: '15%',
    fontSize: 12,
    fontWeight: 'extrabold',
  },
});

interface RowProps {
  reports: IReport[];
  type: string;
}

export const Row = ({ reports, type }: RowProps) => {
  if (type === 'instagram') {
    return (
      <>
        <View style={styles.thead}>
          <Text style={styles.cellThLarge}>Titulo do post</Text>
          <Text style={styles.cellThSmall}>{reports.find(r => r.campaign != null) ? 'Campanha' : 'Influenciador'}</Text>
          <Text style={styles.cellThSmall}>Tipo</Text>
          <Text style={styles.cellThSmall}>Likes</Text>
          <Text style={styles.cellThSmall}>Comentários</Text>
        </View>

        {reports.map((item, index) => (
          <View
            style={(index + 1) % 2 === 0 ? styles.rowEven : styles.rowOdd}
            key={item.reportContentId}
          >
            <Text style={styles.cellTdLarge}>{item.reportContentNameLive}</Text>
            <Text style={styles.cellTdSmall}>{item.campaign ? item.campaign?.nameCampaign : item.name}</Text>
            <Text style={styles.cellTdSmall}>{item.reportContentType}</Text>
            <Text style={styles.cellTdSmall}>{item.reportContentLike}</Text>
            <Text style={styles.cellTdSmall}>{item.reportContentMsg}</Text>
          </View>
        ))}
      </>
    );
  }

  return (
    <>
      <View style={styles.thead}>
        <Text style={styles.cellThLarge}>Nome da live</Text>
        <Text style={styles.cellThLarge}>{reports.find(r => r.campaign != null) ? 'Campanha' : 'Influenciador'}</Text>
        <Text style={styles.cellThSmall}>Views</Text>
        <Text style={styles.cellThSmall}>Bits</Text>
        <Text style={styles.cellThSmall}>Duração</Text>
        <Text style={styles.cellThSmall}>Follow</Text>
      </View>

      {reports.map((item, index) => (
        <View
          style={(index + 1) % 2 === 0 ? styles.rowEven : styles.rowOdd}
          key={item.reportContentId}
        >
          <Text style={styles.cellTdLarge}>{item.reportContentNameLive}</Text>
          <Text style={styles.cellTdSmall}>{item.campaign ? item.campaign?.nameCampaign : item.name}</Text>
          <Text style={styles.cellTdSmall}>{item.reportContentView}</Text>
          <Text style={styles.cellTdSmall}>{item.reportContentBit}</Text>
          <Text style={styles.cellTdSmall}>{item.reportContentTimeLive}</Text>
          <Text style={styles.cellTdSmall}>{item.reportContentFollow}</Text>
        </View>
      ))}
    </>
  );
};
